<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{ $t('changeDelivery') }}</h4>       
            <!-- Expected shipping date -->
            <div role="group" class="form-group flex-grow-1">
                <label class="m-0"> {{ $t('expectedShippingDate') }}</label>
                <CInput class="m-0" type="date" v-model="expectedShippingDate"></CInput>
            </div>     
            <!-- Confirm -->
            <div class="d-flex justify-content-center">  
                <CSpinner v-if="putOrderUpdateShippingOutput === null" variant="success" small></CSpinner>
                <CButton v-else :disabled="expectedShippingDate == null || !orders || !orders.length" type="button" class="mb-4 btn btn-primary align-self-center" @click="confirmRequested">{{ $t('confirm') }}</CButton>
            </div>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { mapState, mapActions } from 'vuex'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

export default {
    extends: BasePopUp,
    components: {BasePopUp, SingleOptionDropdown},
    methods:{
        ...mapActions('orders', ['putOrderUpdateShipping']),
        confirmRequested()
        {       
            var input = {ids: this.orders.map(x=> x.id), date: this.expectedShippingDate};
            this.putOrderUpdateShipping(input);
        },
        closeConfirmRequested()
        {
            this.$emit("closeConfirmRequested");
        }
    },
    data() {
        return {
            expectedShippingDate: null
        };
    },
    computed:
    {
        ...mapState('orders', ['putOrderUpdateShippingOutput']),
    },
    props:{
        orders:
        {
            type: Array
        },
    },
    watch:
    {
        putOrderUpdateShippingOutput: function(val)
        {
            if(val)
            {
                this.$emit("closeConfirmRequested", true);
            }
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }
</style>